/* ============================================================================
 * Project        : Deloitte Digital Compliance
 * File           : StepBasicDetails.jsx
 * Version        : 1.0.0
 * Author         : Team Neubinary
 * Created On     : 2026-06-24
 *
 * Description    : Digital Compliance for Automation and Governance
 *
 * Change History :
 * ----------------------------------------------------------------------------
 * Date         | Version | Author           | Description
 * ----------------------------------------------------------------------------
 * 2026-06-24   | 1.0.0   | Team Neubinary   | Initial creation
 * <YYYY-MM-DD> | x.x.x   | <Name/Team>      | <Change description>
 * ============================================================================
 *
 * Copyright (c) 2026 AU79 Consulting Services Pvt. Ltd.
 * All Rights Reserved.
 *
 * This source code and its contents are confidential and proprietary to
 * AU79 Consulting Services Pvt. Ltd. Unauthorized copying, reproduction,
 * modification, distribution, or disclosure of this material, in whole or
 * in part, is strictly prohibited without prior written permission from
 * AU79 Consulting Services Pvt. Ltd.
 * ============================================================================
 */


import React from "react";
import PropTypes from "prop-types";
import { Box, Typography } from "@mui/material";
import CustomFormTextFieldV2 from "../../../../components/customComponentsV2/common/textField/CustomFormTextFieldV2";

function StepBasicDetails({ value = {}, errors = {}, onChange }) {
  const { name = "", description = "" } = value;

  return (
    <Box sx={{ maxWidth: "100%" }}>
      <Typography
        variant="h6"
        sx={{ mb: 4, display: "flex", alignItems: "start" }}
      >
        Specify rule set details
      </Typography>
      <CustomFormTextFieldV2
        label="Rule Set Name"
        required
        value={name}
        isMultiline
        setValue={(v) => onChange({ ...value, name: v })}
        valueError={errors.name}
      />

      <CustomFormTextFieldV2
        label="Description"
        value={description}
        setValue={(v) => onChange({ ...value, description: v })}
        isMultiline
        valueError={errors.description}
      />
      {errors._form && (
        <Typography color="error" sx={{ mt: 1 }}>
          {errors._form}
        </Typography>
      )}
    </Box>
  );
}

StepBasicDetails.propTypes = {
  value: PropTypes.shape({
    name: PropTypes.string,
    description: PropTypes.string,
  }),
  errors: PropTypes.shape({
    name: PropTypes.string,
    description: PropTypes.string,
    _form: PropTypes.string,
  }),
  onChange: PropTypes.func,
};

export default StepBasicDetails;
